import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/onbording';
import { IOnbordingState } from '../../types/redux/onbording';

export const initialState: IOnbordingState = {
  data: [],
};

export const onbordingReducer = (state = initialState, action: TReduxActions): IOnbordingState => {
  if (action.type === EActionTypes.SetOnbordingData) {
    return {
      ...state,
      data: action.payload,
    };
  }

  return state;
};
